import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SideBarContext';
import ProtectedRoute from './components/ProtectedRoute';
import AccessDenied from './components/AccessDenied';
import Register from "./components/RegisterPage";
import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import Calendario from "./components/Calendario";
import Usuarios from "./components/Usuarios";
import RegistrarUsuario from "./components/RegistrarUsuario";
import ActualizarUsuario from "./components/ActualizarUsuario";
import GeneralReportPage from "./components/ReportesGeneral";
import Parametros from "./components/Parametros";
import AddParameters from "./components/AñadirParametros";
import VistaParametrosLectura from "./components/VistaParametrosLectura";
import Lista from "./components/Lista";
import NegativizarExpress from "./components/Negativizarexpress";
import EditExpress from "./components/VistaExpressLectura"
import Sugerencias from "./components/Sugerencias"
import Reportes from "./components/Reportes";
import MergeReport from "./components/MergeReportes"
import RestablecerContrasena from "./components/RestablecerContrasena";
import AdsDashboardPage from './components/AdsDashboardPage';
import SponsoredProducts from './components/SponsoredProducts';
import SponsoredBrands from './components/SponsoredBrands';
import SponsoredDisplay from './components/SponsoredDisplay';
import SpaSingleKeyword from './components/SpaSingleKeyword';
import SdProductCampaigns from './components/SdProductCampaigns';
import SbGroupKeywordCampaigns from './components/SbGroupKeywordCampaigns';
import SbSingleKeywordCampaigns from './components/SbSingleKeywordCampaigns';
import SbVerticalVideoCampaigns from './components/SbVerticalVideoCampaigns';
import SbHorizontalVideoCampaigns from './components/SbHorizontalVideoCampaigns';
import SbProductCollectionCampaigns from './components/SbProductCollectionCampaigns';
import SpProductCampaigns from './components/SpProductCampaigns';
import SpKeywordGroup from './components/SpKeywordGroup';
import SpSeoCampaigns from './components/SpSeoCampaigns';
import SpCategoryCampaigns from './components/SpCategoryCampaigns';
import SpBrandProtectionKeywords from './components/SpBrandProtectionKeywords';
import SpBrandProtectionProducts from './components/SpBrandProtectionProducts';
import SpAutoSingleTarget from './components/SpAutoSingleTarget';
import SpAutoMultiTarget from './components/SpAutoMultiTarget';
import SalesEstimateBasketManager from './components/analysis/SalesEstimateBasketManager';

// Tracking & Analysis modules
import TrackingOverview from './components/tracking/TrackingOverview';
import SchedulerConfig from './components/tracking/SchedulerConfig';
import PricingBreakdown from './components/tracking/PricingBreakdown';
import RatingEvolution from './components/tracking/RatingEvolution';
import RankingEvolution from './components/tracking/RankingEvolution';
import BestSellersRank from './components/tracking/BestSellersRank';
import DetailedTable from './components/tracking/DetailedTable';
import WebTraffic from './components/tracking/WebTraffic';
import MediaTracking from './components/tracking/MediaTracking';
import MediaChangeHistory from './components/tracking/MediaChangeHistory';
import NgramAnalysis from './components/analysis/NgramAnalysis';
import CampaignsEvolution from './components/analysis/CampaignsEvolution';
import PlacementsSP from './components/analysis/PlacementsSP';
import PlacementsSB from './components/analysis/PlacementsSB';
import ParametersAnalysis from './components/analysis/ParametersAnalysis';
import SalesEstimate from './components/analysis/SalesEstimate';

const ROLES = {
    SUPER: 1,
    ADMIN: 2,
    ANALISTA: 3,
    INVITADO: 4
};

function App() {
    return (
        <AuthProvider>
            <SidebarProvider>
                <Router>
                    <Routes>
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/forgot-password" element={<RestablecerContrasena />} />
                        <Route path="/acceso-denegado" element={<AccessDenied />} />

                        <Route path="/" element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        } />

                        <Route path="/dashboard" element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        } />

                        <Route path="/calendario" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.ANALISTA, ROLES.SUPER, ROLES.INVITADO]}>
                                <Calendario />
                            </ProtectedRoute>
                        } />
                        <Route path="/reportes-general" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.ANALISTA, ROLES.SUPER, ROLES.INVITADO]}>
                                <GeneralReportPage />
                            </ProtectedRoute>
                        } />

                        <Route path="/listas" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.ANALISTA, ROLES.SUPER, ROLES.INVITADO]}>
                                <Lista />
                            </ProtectedRoute>
                        } />

                        <Route path="/negativizarExpress" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.ANALISTA, ROLES.SUPER]}>
                                <NegativizarExpress />
                            </ProtectedRoute>
                        } />

                        <Route path="/editExpress" element={
                            <ProtectedRoute allowedRoles={[ROLES.SUPER]}>
                                <EditExpress />
                            </ProtectedRoute>
                        } />

                        <Route path="/parametros" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA, ROLES.INVITADO]}>
                                <Parametros />
                            </ProtectedRoute>
                        } />

                        <Route path="/añadir-parametro" element={
                            <ProtectedRoute allowedRoles={[ROLES.SUPER]}>
                                <AddParameters />
                            </ProtectedRoute>
                        } />

                        <Route path="/anadir-parametro" element={
                            <ProtectedRoute allowedRoles={[ROLES.SUPER]}>
                                <AddParameters />
                            </ProtectedRoute>
                        } />

                        <Route path="/editar-parametro" element={
                            <ProtectedRoute allowedRoles={[ROLES.SUPER]}>
                                <VistaParametrosLectura />
                            </ProtectedRoute>
                        } />
                        <Route path="/usuarios" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <Usuarios />
                            </ProtectedRoute>
                        } />
                        <Route path="/registrar-usuario" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <RegistrarUsuario />
                            </ProtectedRoute>
                        } />
                        <Route path="/actualizar-usuario/:id" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <ActualizarUsuario />
                            </ProtectedRoute>
                        } />
                        <Route path="/reportesCSV" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <Reportes />
                            </ProtectedRoute>
                        } />
                        <Route path="/mergeReport" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <MergeReport />
                            </ProtectedRoute>
                        } />
                        <Route path="/sugerencias" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER]}>
                                <Sugerencias />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads-dashboard" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <AdsDashboardPage />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-single-keyword" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpaSingleKeyword />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sponsored-products" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SponsoredProducts />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sponsored-brands" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SponsoredBrands />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sponsored-display" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SponsoredDisplay />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sd-product-campaigns" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SdProductCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sb-keyword-group" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SbGroupKeywordCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sb-single-keyword" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SbSingleKeywordCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sb-vertical-video" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SbVerticalVideoCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sb-horizontal-video" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SbHorizontalVideoCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sb-product-collection" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SbProductCollectionCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-product" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpProductCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-keyword-group" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpKeywordGroup />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-product-seo" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpSeoCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-category" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpCategoryCampaigns />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-brand-keywords" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpBrandProtectionKeywords />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-brand-products" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpBrandProtectionProducts />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-auto-single" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpAutoSingleTarget />
                            </ProtectedRoute>
                        } />
                        <Route path="/ads/sp-auto-multi" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SpAutoMultiTarget />
                            </ProtectedRoute>
                        } />

                        {/* Competitor Tracking Routes */}
                        <Route path="/tracking/overview" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <TrackingOverview />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/pricing" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <PricingBreakdown />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/rating" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <RatingEvolution />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/ranking" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <RankingEvolution />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/media" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <MediaTracking />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/media-history" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <MediaChangeHistory />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/best-sellers" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <BestSellersRank />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/detailed" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <DetailedTable />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/web-traffic" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <WebTraffic />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/scheduler-config" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER]}>
                                <SchedulerConfig />
                            </ProtectedRoute>
                        } />
                        <Route path="/tracking/config" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER]}>
                                <SchedulerConfig />
                            </ProtectedRoute>
                        } />

                        {/* File Analysis Routes */}
                        <Route path="/analysis/ngram" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <NgramAnalysis />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/campaigns" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <CampaignsEvolution />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/placements-sp" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <PlacementsSP />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/placements-sb" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <PlacementsSB />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/parameters" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <ParametersAnalysis />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/sales-estimate" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SalesEstimate />
                            </ProtectedRoute>
                        } />
                        <Route path="/analysis/sales-estimate-baskets" element={
                            <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.SUPER, ROLES.ANALISTA]}>
                                <SalesEstimateBasketManager />
                            </ProtectedRoute>
                        } />
                    </Routes>
                </Router>
            </SidebarProvider>
        </AuthProvider>
    );
}

export default App;